(function() {
	'use strict';

	angular.module('crewDownloads').config(config);

	function config($stateProvider) {
		$stateProvider
				.state(
						'crewDownloads',
						{
							url : '/crew-downloads',
							views : {
								'crewDownloadsView' : {
									templateUrl : 'crew-downloads/views/crew-downloads.tpl.html',
									controller : 'CrewDownloadsCtrl',
									controllerAs : 'crewDownloads'
								}
							}
						});
	}
}());
